
import { useState, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import { SubjectGet, SubjectSave } from 'services/subjectService'
import {toast} from 'react-hot-toast'
import { ArrowLeft, Save } from 'lucide-react';

export default function EditSubjectPage() {
    const {id}: any = useParams()
    const router = useHistory()
    const [name, setName] = useState('')
    const [code, setCode] = useState('')
    const [type, setType] = useState('1')
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const fetchSubject = async () => {
            try {
                const response = await SubjectGet(id as string)
                if (!response.result) {
                    throw new Error('Failed to fetch subject')
                }
                const data = response.result
                setName(data.name)
                setCode(data.code || '')
                setType(data.type.toString())
            } catch (err) {
                setError('Không thể tải thông tin môn học')
            }
        }

        fetchSubject()
    }, [id])

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        if (!name) {
            setError('Vui lòng nhập tên môn học')
            return
        }

        setIsLoading(true)
        setError('')

        try {
            const response = await SubjectSave({
                id: id as string,
                name,
                code: code || null,
                type: parseInt(type) as 1 | 2
            })

            if (!response.message) {
                throw new Error('Lỗi cập nhật môn học: ' + response.message)
            }
            toast.success('Cập nhật môn học thành công')

            router.push('/subjects')
        } catch (err: any) {
            setError(err.message || 'Đã xảy ra lỗi khi cập nhật môn học')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="flex justify-between items-center mb-6">
                <Link
                    to="/subjects"
                    className="flex items-center text-blue-600 hover:text-blue-800"
                >
                    <ArrowLeft className="mr-2" />
                    Quay lại
                </Link>
                <h1 className="text-3xl font-bold text-gray-800">Chỉnh sửa môn học</h1>
                <div></div>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 max-w-2xl mx-auto">
                {error && (
                    <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                            Tên môn học *
                        </label>
                        <input
                            type="text"
                            id="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                    </div>

                    <div className="mb-4">
                        <label htmlFor="code" className="block text-sm font-medium text-gray-700 mb-1">
                            Mã môn học
                        </label>
                        <input
                            type="text"
                            id="code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>

                    <div className="mb-6">
                        <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1">
                            Loại môn học *
                        </label>
                        <select
                            id="type"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            required
                        >
                            <option value="1">Lý thuyết</option>
                            <option value="2">Thực hành</option>
                        </select>
                    </div>

                    <div className="flex justify-end">
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                        >
                            {isLoading ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Đang lưu...
                                </>
                            ) : (
                                <>
                                    <Save className="mr-2" />
                                    Lưu thông tin
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}